document.addEventListener("DOMContentLoaded", () => {
  // --- SCOPE GLOBALE DELL'APP GARAGE ---
  const garageApp = {
    motoMap: {},
    customerId: window.customerId || null,
    translations: {},

    // --- FUNZIONI HELPER ---
    toHandle(s) {
      return s.toLowerCase().trim()
        .replace(/\+/g, "-")
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9\-]/g, "")
        .replace(/-+/g, "-");
    },

    getLocalizedCollectionUrl(handle) {
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        const langPrefix = (pathParts.length > 0 && /^[a-z]{2}(-[a-z]{2})?$/.test(pathParts[0])) ? `/${pathParts[0]}` : '';
        return `${langPrefix}/collections/all/${handle}`;
    },

    normalizeGarageArray(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.map(i => {
        if (typeof i === "string") {
          const parts = i.trim().split(" ");
          if (parts.length < 3) return null;
          const anno = parts.pop();
          const brand = parts.shift();
          const modello = parts.join(" ");
          return { brand, modello, anno };
        } else if (i && i.brand && i.modello && i.anno) {
          return { brand: i.brand.trim(), modello: i.modello.trim(), anno: i.anno.trim() };
        }
        return null;
      }).filter(Boolean);
    },

    populateSelect(selectEl, options, placeholder) {
      if (!selectEl) return;
      selectEl.innerHTML = '';
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = placeholder;
      selectEl.appendChild(defaultOption);
      options.forEach(opt => {
        const optionEl = document.createElement('option');
        optionEl.value = opt;
        optionEl.textContent = opt;
        selectEl.appendChild(optionEl);
      });
      selectEl.disabled = options.length === 0;
    },

    // --- API GARAGE ---
    async getGarage() {
      if (this.customerId) {
        try {
          const res = await fetch(`https://thoth.kelleradvhost.com/ct-mg/garage.php?customer_id=${this.customerId}`);
          const data = await res.json();
          return this.normalizeGarageArray(data.garage || []);
        } catch (e) { return []; }
      }
      return this.normalizeGarageArray(JSON.parse(localStorage.getItem("motoGarage") || "[]"));
    },

    async setGarage(garageArr) {
      const garage = this.normalizeGarageArray(garageArr);
      if (this.customerId) {
        try {
          await fetch("https://thoth.kelleradvhost.com/ct-mg/garage.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ customer_id: this.customerId, garage })
          });
        } catch (e) { console.error("Errore POST garage server:", e); }
      }
      localStorage.setItem("motoGarage", JSON.stringify(garage));
      this.updateGarageUI(garage);
      return garage;
    },

    async addToGarage(moto) {
      if (!moto.brand || !moto.modello || !moto.anno) return;
      let garage = await this.getGarage();
      const exists = garage.some(i => i.brand === moto.brand && i.modello === moto.modello && i.anno === moto.anno);
      if (!exists) {
        garage.push(moto);
        await this.setGarage(garage);
      }
    },

    // --- GESTIONE UI ---
    updateGarageUI(garage) {
      const countEls = document.getElementsByClassName("garage-count");
      for (let el of countEls) {
        el.textContent = (garage || []).length;
      }
      this.renderGarageList(garage);
    },

    renderGarageList(garage) {
      const list = document.getElementById("garage-list");
      if (!list) return;
      list.innerHTML = "";
      (garage || []).forEach((item, i) => {
        const label = `${item.anno} ${item.brand} ${item.modello}`;
        const handle = this.toHandle(label);
        const url = this.getLocalizedCollectionUrl(handle);
        const li = document.createElement("li");
        li.innerHTML = `
          <a href="${url}" target="_blank" style="flex-grow: 1;">${label}</a>
          <button class="remove-moto" data-index="${i}">×</button>
        `;
        list.appendChild(li);
      });
    },

    // --- INIZIALIZZAZIONE MODULI ---
    initGarageModal() {
      const modal = document.getElementById("garage-modal");
      if (!modal) return;

      const brandSelect = document.getElementById("brand");
      const modelloSelect = document.getElementById("modello");
      const annoSelect = document.getElementById("anno");
      const addMotoBtn = document.getElementById("add-moto");
      const garageList = document.getElementById("garage-list");

      const initSelects = () => {
        const brands = Object.keys(this.motoMap).sort();
        this.populateSelect(brandSelect, brands, this.translations.selectBrand);
        this.populateSelect(modelloSelect, [], this.translations.selectModel);
        this.populateSelect(annoSelect, [], this.translations.selectYear);
        modelloSelect.disabled = true;
        annoSelect.disabled = true;
      };

      brandSelect.addEventListener('change', () => {
        const brand = brandSelect.value;
        const models = brand ? Object.keys(this.motoMap[brand] || {}).sort() : [];
        this.populateSelect(modelloSelect, models, this.translations.selectModel);
        this.populateSelect(annoSelect, [], this.translations.selectYear);
        annoSelect.disabled = true;
      });

      modelloSelect.addEventListener('change', () => {
        const brand = brandSelect.value;
        const modello = modelloSelect.value;
        const anni = (brand && modello) ? (this.motoMap[brand]?.[modello] || []) : [];
        this.populateSelect(annoSelect, anni, this.translations.selectYear);
      });

      addMotoBtn.addEventListener('click', async () => {
        const brand = brandSelect.value.trim();
        const modello = modelloSelect.value.trim();
        const anno = annoSelect.value.trim();
        if (!brand || !modello || !anno) return alert("Seleziona tutti i campi");
        
        await this.addToGarage({ brand, modello, anno });
        const handle = this.toHandle(`${anno} ${brand} ${modello}`);
        window.location.href = this.getLocalizedCollectionUrl(handle);
      });

      garageList.addEventListener("click", async (e) => {
        if (e.target.classList.contains("remove-moto")) {
          const index = parseInt(e.target.dataset.index, 10);
          let garage = await this.getGarage();
          garage.splice(index, 1);
          await this.setGarage(garage);
        }
      });
      
      const garageButtons = [...document.querySelectorAll("#garage-button-floating, #garage-button")];
      garageButtons.forEach(button => {
        button.addEventListener("click", async () => {
          initSelects();
          modal.style.display = "flex";
          document.body.style.overflow = "hidden";
          const garage = await this.getGarage();
          this.updateGarageUI(garage);
        });
      });

      document.getElementById("close-garage").addEventListener("click", () => {
        modal.style.display = "none";
        document.body.style.overflow = "";
      });
    },

    initAccessoriSelector() {
      const container = document.getElementById('accessori-selector');
      if (!container) return;

      const brandSelect = document.getElementById('accessori-brand');
      const modelloSelect = document.getElementById('accessori-modello');
      const annoSelect = document.getElementById('accessori-anno');
      const btnAccessori = document.getElementById('btn-accessori');

      const brands = Object.keys(this.motoMap).sort();
      this.populateSelect(brandSelect, brands, this.translations.selectBrand);

      brandSelect.addEventListener('change', () => {
        const brand = brandSelect.value;
        const models = brand ? Object.keys(this.motoMap[brand] || {}).sort() : [];
        this.populateSelect(modelloSelect, models, this.translations.selectModel);
        this.populateSelect(annoSelect, [], this.translations.selectYear);
        annoSelect.disabled = true;
        btnAccessori.disabled = true;
      });

      modelloSelect.addEventListener('change', () => {
        const brand = brandSelect.value;
        const modello = modelloSelect.value;
        const anni = (brand && modello) ? (this.motoMap[brand]?.[modello] || []) : [];
        this.populateSelect(annoSelect, anni, this.translations.selectYear);
        btnAccessori.disabled = true;
      });

      annoSelect.addEventListener('change', () => {
        btnAccessori.disabled = !annoSelect.value;
      });

      btnAccessori.addEventListener('click', async () => {
        const brand = brandSelect.value.trim();
        const modello = modelloSelect.value.trim();
        const anno = annoSelect.value.trim();
        if (!brand || !modello || !anno) return;

        await this.addToGarage({ brand, modello, anno });
        const handle = this.toHandle(`${anno} ${brand} ${modello}`);
        window.location.href = this.getLocalizedCollectionUrl(handle);
      });
    },

    initProductCompatibilityChecker() {
      const container = document.getElementById('product-compatibility-checker');
      if (!container || !window.productTags) return;

      const productCompatibleMotos = (window.productTags || []).map(tag => {
        const parts = tag.split('+');
        if (parts.length < 3) return null;
        
        const yearRange = parts[0];
        // --- MODIFICA PER MODELLI COMPOSTI ---
        const brand = parts[1].replace(/-/g, ' ');
        const modello = parts.slice(2).join(' ').replace(/-/g, ' ');
        // --- FINE MODIFICA ---

        const yearParts = yearRange.split('-');
        const startYear = parseInt(yearParts[0], 10);
        const endYear = parseInt(yearParts[1] || yearParts[0], 10);

        if (isNaN(startYear) || isNaN(endYear)) return null;

        return { startYear, endYear, brand, modello };
      }).filter(Boolean);

      if (productCompatibleMotos.length === 0) {
        container.style.display = 'none';
        return;
      }

      // --- INIZIO LOGICA CORRETTA ---
      const isMotoCompatible = (userMoto, compatList) => {
        const userYear = parseInt(userMoto.anno, 10);
        if (isNaN(userYear)) return false;

        return compatList.some(pMoto =>
          userMoto.brand.toLowerCase() === pMoto.brand.toLowerCase() &&
          userMoto.modello.toLowerCase().startsWith(pMoto.modello.toLowerCase()) && // <-- Confronto "startsWith"
          userYear >= pMoto.startYear &&
          userYear <= pMoto.endYear
        );
      };
      // --- FINE LOGICA CORRETTA ---

      const renderCompatibleList = (compatibleGarageMotos) => {
        let listItems = compatibleGarageMotos.map(moto => `<li>${moto.brand} ${moto.modello} ${moto.anno}</li>`).join('');
        container.innerHTML = `
          <h3 class="compatibility-title">${this.translations.compatibleWith}</h3>
          <ul class="compatible-list">${listItems}</ul>`;
      };

      const renderSelectorForm = (garage) => {
        const hasMotosInGarage = garage.length > 0;
        const title = hasMotosInGarage ? this.translations.noMotoCompatible : this.translations.discoverIfPerfect;
        
        let garageListHtml = '';
        if (hasMotosInGarage) {
          garageListHtml += `<div style="margin-top: 24px; border-top: 1px solid #e0e0e0; padding-top: 20px;">`;
          garageListHtml += `<h4 class="compatibility-title" style="font-size: 1rem; margin-bottom: 12px;">${this.translations.orExplore}</h4>`;
          garageListHtml += `<ul style="list-style: none; padding: 0; margin: 0;">`;
          garage.forEach(moto => {
            const label = `${moto.anno} ${moto.brand} ${moto.modello}`;
            const handle = this.toHandle(label);
            const url = this.getLocalizedCollectionUrl(handle);
            garageListHtml += `
              <li style="margin-bottom: 8px; display: flex; justify-content: space-between; align-items: center;">
                <span>${moto.brand} ${moto.modello} ${moto.anno}</span>
                <a href="${url}" style="font-size: 0.9rem; font-weight: 600; text-decoration: underline;">${this.translations.viewProducts}</a>
              </li>`;
          });
          garageListHtml += `</ul></div>`;
        }

        container.innerHTML = `
          <h3 class="compatibility-title">${title}</h3>
          <div class="compatibility-selector-form">
            <select id="compat-brand"><option>${this.translations.selectBrand}</option></select>
            <select id="compat-modello" disabled><option>${this.translations.selectModel}</option></select>
            <select id="compat-anno" disabled><option>${this.translations.selectYear}</option></select>
            <button id="compat-check-btn" disabled>${this.translations.checkCompatibility}</button>
          </div>
          <div id="compatibility-result-display"></div>
          ${garageListHtml}
        `;
        
        const brandSelect = document.getElementById('compat-brand');
        const modelloSelect = document.getElementById('compat-modello');
        const annoSelect = document.getElementById('compat-anno');
        const checkBtn = document.getElementById('compat-check-btn');

        this.populateSelect(brandSelect, Object.keys(this.motoMap).sort(), this.translations.selectBrand);
        brandSelect.addEventListener('change', () => {
            const models = brandSelect.value ? Object.keys(this.motoMap[brandSelect.value] || {}).sort() : [];
            this.populateSelect(modelloSelect, models, this.translations.selectModel);
            this.populateSelect(annoSelect, [], this.translations.selectYear);
            annoSelect.disabled = true;
            checkBtn.disabled = true;
        });
        modelloSelect.addEventListener('change', () => {
            const anni = (brandSelect.value && modelloSelect.value) ? (this.motoMap[brandSelect.value]?.[modelloSelect.value] || []) : [];
            this.populateSelect(annoSelect, anni, this.translations.selectYear);
            checkBtn.disabled = true;
        });
        annoSelect.addEventListener('change', () => { checkBtn.disabled = !annoSelect.value; });
        checkBtn.addEventListener('click', handleCheck);
      };

      const handleCheck = async () => {
        const brand = document.getElementById('compat-brand').value;
        const modello = document.getElementById('compat-modello').value;
        const anno = document.getElementById('compat-anno').value;
        if (!brand || !modello || !anno) return;
        
        const selectedMoto = { brand, modello, anno };
        await this.addToGarage(selectedMoto);

        const isCompatible = isMotoCompatible(selectedMoto, productCompatibleMotos);
        const resultDisplay = document.getElementById('compatibility-result-display');
        
        if (isCompatible) {
          resultDisplay.innerHTML = `<div class="compatibility-result success">${this.translations.greatChoice} ${brand} ${modello} ${anno}.</div>`;
        } else {
          const handle = this.toHandle(`${anno} ${brand} ${modello}`);
          const collectionUrl = this.getLocalizedCollectionUrl(handle);
          resultDisplay.innerHTML = `<div class="compatibility-result failure">${this.translations.notCompatible} <a href="${collectionUrl}">${this.translations.viewAccessories} ${brand} ${modello} ${anno}</a>.</div>`;
        }
      };

      this.getGarage().then(garage => {
        const compatibleGarageMotos = garage.filter(gMoto => isMotoCompatible(gMoto, productCompatibleMotos));
        if (compatibleGarageMotos.length > 0) {
          renderCompatibleList(compatibleGarageMotos);
        } else {
          renderSelectorForm(garage);
        }
      });
    },

    // --- METODO DI AVVIO PRINCIPALE ---
    async init() {
      const translationContainer = document.getElementById('garage-translations');
      if (translationContainer) {
        this.translations = {
          compatibleWith: translationContainer.querySelector('[data-string-compatible-with]').textContent,
          noMotoCompatible: translationContainer.querySelector('[data-string-no-moto-compatible]').textContent,
          discoverIfPerfect: translationContainer.querySelector('[data-string-discover-if-perfect]').textContent,
          checkCompatibility: translationContainer.querySelector('[data-string-check-compatibility]').textContent,
          greatChoice: translationContainer.querySelector('[data-string-great-choice]').textContent,
          notCompatible: translationContainer.querySelector('[data-string-not-compatible]').textContent,
          viewAccessories: translationContainer.querySelector('[data-string-view-accessories]').textContent,
          orExplore: translationContainer.querySelector('[data-string-or-explore]').textContent,
          viewProducts: translationContainer.querySelector('[data-string-view-products]').textContent,
          selectBrand: translationContainer.querySelector('[data-string-select-brand]').textContent,
          selectModel: translationContainer.querySelector('[data-string-select-model]').textContent,
          selectYear: translationContainer.querySelector('[data-string-select-year]').textContent,
        };
      } else {
        console.error("Contenitore traduzioni non trovato!");
      }

      try {
        const res = await fetch("https://thoth.kelleradvhost.com/ct-mg/moto_map.php");
        this.motoMap = await res.json() || {};
        
        this.initGarageModal();
        this.initAccessoriSelector();
        this.initProductCompatibilityChecker();

        const garage = await this.getGarage();
        this.updateGarageUI(garage);

      } catch (err) {
        console.error("Errore critico nel caricamento dell'app garage:", err);
      }
    }
  };

  garageApp.init();
});